import http from 'axios';
import base64 from 'base-64';
import { API_URL, API_URL_POST, FUNCTION_KEY } from '../runtimeConfig';

const ProductsService = () => {
  const getProducts = async (search, filters) => {
    let url = API_URL_POST + '/shop/products?' + 'code=' + FUNCTION_KEY;

    if (filters.page) {
      url += `&page=${filters.page}&`;
    }
    if (filters.pageSize) {
      url += `pageSize=${filters.pageSize}&`;
    }

    try {
      const res = await http.post(url, { search, filters });

      // Map backend response (PascalCase) to frontend format (camelCase)
      const mappedData = {
        result: res.data.result || res.data.Result || [],
        pages: res.data.pages || res.data.Pages || [],
        page: res.data.page || res.data.Page || 1,
        pageSize: res.data.pageSize || res.data.PageSize || 30,
        totalCount: res.data.totalCount || res.data.TotalCount || 0,
        totalPages: res.data.totalPages || res.data.TotalPages || 0
      };

      // const cacheName = 'products';
      // const cache = await caches.open(cacheName);
      // res.data.result.forEach(async (item) => {
      //   const response = new Response(JSON.stringify(item), {
      //     headers: { 'Content-Type': 'application/json' }
      //   });
      //   await cache.put(`product_${item.no}`, response.clone());
      // });
      return mappedData;
    } catch (err) {
      console.log(err);
      // Return base structure on error
      return { result: [], pages: [], page: 1, pageSize: 30, totalCount: 0, totalPages: 0 };
    }
  }


  const getProductImages = async (id) => {
    const cacheName = 'product-images';
    const cache = await caches.open(cacheName);
    const cachedResponse = await cache.match(`productImage_${id}`);
    if (cachedResponse) {
      return cachedResponse.text();
    }

    const url = API_URL + `/shop/products/${base64.encode(id)}/images`;

    try {
      const res = await http.get(url);
      const pictureBase64 = res.data.pictureBase64;
      const response = new Response(pictureBase64, {
        headers: { 'Content-Type': 'text/plain' }
      });
      await cache.put(`productImage_${id}`, response.clone());
      return pictureBase64;
    } catch (err) {
      console.error(err);
      return '';
    }
  };

  const getProductFilters = async () => {
    const url = API_URL + '/shop/products/filters';

    try {
      const res = await http.get(url);
      const d = res.data || {};
      // Backend returns PascalCase, frontend expects camelCase. Normalize once here.
      return {
        categories: (d.categories || d.Categories || []).map(String),
        brand: (d.brand || d.Brand || []).map(String),
        radius: (d.radius || d.Radius || []).map(String),
        wall: (d.wall || d.Wall || []).map(String),
        diameter: (d.diameter || d.Diameter || []).map(String),
      };
    } catch (err) {
      console.log(err);
      return { categories: [], brand: [], radius: [], wall: [], diameter: [] };
    }
  }

  const getProduct = async (id) => {
    const url = API_URL + `/shop/products/${base64.encode(id)}`;

    try {
      const res = await http.get(url);
      const product = res.data[0];
      
      // Map backend response (PascalCase) to frontend format (camelCase)
      const mappedProduct = {
        no: product.No,
        description: product.Description,
        brand: product.Brand,
        price: product.Price,
        unitPrice: product.Price, // Alias for compatibility
        inventory: product.Inventory,
        availableInventory: product.Inventory, // Use Inventory as available
        category: product.Category,
        diameter: product.Diameter,
        radius: product.Radius,
        wall: product.Wall,
        commonItemNo: product.CmmonItemNo,
        systemId: product.SystemId,
        createdAt: product.CreatedAt,
        modifiedAt: product.ModifiedAt
      };
      
      return mappedProduct;
    } catch (err) {
      console.log(err);
    }
  }


  return { getProducts, getProductImages, getProductFilters, getProduct };

}

export default ProductsService;